export default __webpack_public_path__ + "static/media/place_holder_News.7f43fe9f.svg";